<template>
    <div class="form-nested-accordion">
        <div class="row" v-if="!loadingDistribuicao">

            <div class="col-md-12">
                <div class="row">
                    <div class="alert alert-warning">
                        <span><strong>CALCULADORA SOLAR</strong></span>
                    </div>
                </div>
                <div class="row">
                    <dl>
                        <dt class="yellowLegend"></dt>
                        <dd>Em Análise</dd>

                        <dt class="greenLegend"></dt>
                        <dd>Aprovados</dd>
                    </dl>
                </div>
                <div class="row">
                    <div class="col-xs-12">

                        <vue-good-table :columns="columns"
                                        :rows="registros"
                                        :sort-options="{enabled: false}"                                         
                                        :fixed-header="true"
                                        :row-style-class="rowStyleClassFn"
                                        styleClass="vgt-table">
                            <template slot="table-row" slot-scope="props">                                
                                <span v-if="props.column.field == 'before' ">
                                    <button v-show="props.row.DIST_STATUS == 'Pendente'" @click="clickAceitarRecusar(props.row.ID,'VISITOU')" class="btn btn-success" style="margin-right:3px; padding: 3px 6px;"><i class="fa fa-check"></i></button>
                                    <button v-show="props.row.DIST_STATUS == 'Pendente'" @click="clickAceitarRecusar(props.row.ID,'RECUSOU')" class="btn btn-danger" style="margin-right:3px; padding: 3px 6px;"><i class="fa fa-user-times"></i></button>
                                    <button v-show="props.row.DIST_STATUS == 'Aprovado'" @click="VisualizarProposta(props.row.ID)" class="btn btn-success" style="margin-right:3px; padding: 3px 6px;" ><i class="fa fa-print"></i></button>
                                </span>
                                <span v-else>
                                    {{props.formattedRow[props.column.field]}}
                                </span>                                
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>
        </div>
        <div id="modal-proposta" class="modal" tabindex="-1" role="dialog" aria-labelledby="integradores" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">                                                
                        <h4 class="modal-title" id="modal-proposta">Orçamento - Calculadora Solar</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row" style=" padding-bottom: 10px; ">
                            <label class="col-md-4 control-label" for="textinput">Código</label>
                            <div class="col-md-8 ml-auto">
                                <input name="ID_LEAD" class="form-control input-md"
                                       type="text"
                                       style="font-weight: 600;
                                              background-color: aliceblue;
                                              border: thick;
                                              color: #023e61;"
                                       readonly      
                                       v-model="frmProposta.ID_LEAD" />
                            </div>
                        </div>
                        <div class="row" style=" padding-bottom: 10px; ">
                            <label class="col-md-4 control-label" for="textinput">Nome</label>
                            <div class="col-md-8 ml-auto">
                                <input name="NOME" class="form-control input-md"
                                       type="text"
                                       style="font-weight: 600;
                                              background-color: aliceblue;
                                              border: thick;
                                              color: #023e61;"
                                       readonly
                                       v-model="frmProposta.NOME" />
                            </div>
                        </div>                        
                        <div class="row" style=" padding-bottom: 10px; ">
                            <label class="col-md-4 control-label" for="textinput">E-mail</label>
                            <div class="col-md-8 ml-auto">
                                <input name="EMAIL" class="form-control input-md"
                                       type="text"
                                       style="font-weight: 600;
                                              background-color: aliceblue;
                                              border: thick;
                                              color: #023e61;"
                                       readonly
                                       v-model="frmProposta.EMAIL" />
                            </div>
                        </div>
                        <div class="row" style=" padding-bottom: 10px; ">
                            <label class="col-md-4 control-label" for="textinput">Cidade</label>
                            <div class="col-md-8 ml-auto">
                                <input name="CIDADE" class="form-control input-md"
                                       type="text"
                                       style="font-weight: 600;
                                              background-color: aliceblue;
                                              border: thick;
                                              color: #023e61;"
                                       readonly
                                       v-model="frmProposta.CIDADE" />
                            </div>
                        </div>
                        <div class="row" style=" padding-bottom: 10px; ">
                            <label class="col-md-4 control-label" for="textinput">Telefone</label>
                            <div class="col-md-8 ml-auto">
                                <input name="TELEFONE" class="form-control input-md"
                                       type="text"  
                                       style="font-weight: 600;
                                              background-color: aliceblue;
                                              border: thick;
                                              color: #023e61;"                                     
                                       readonly
                                       v-model="frmProposta.TELEFONE" />
                            </div>
                        </div>
                        <div class="row" style=" padding-bottom: 10px; ">
                            <label class="col-md-4 control-label" for="textinput">CEP</label>
                            <div class="col-md-8 ml-auto">
                                <input name="CEP" class="form-control cep-mask"
                                       type="text"
                                       style="font-weight: 600;
                                              background-color: aliceblue;
                                              border: thick;
                                              color: #023e61;"
                                       readonly
                                       v-model="frmProposta.CEP" />
                            </div>
                        </div>
                        <div class="row" style=" padding-bottom: 10px; ">
                            <label class="col-md-4 control-label" for="textinput">Código do Produto</label>
                            <div class="col-md-8 ml-auto">
                                <input name="PRODUTO" class="form-control input-md"
                                       type="text"
                                       style="font-weight: 600;
                                              background-color: aliceblue;
                                              border: thick;
                                              color: #023e61;"
                                       readonly
                                       v-model="frmProposta.CODIGO_PRODUTO" />
                            </div>
                        </div>
                        <div class="row" style=" padding-bottom: 10px; ">
                            <label class="col-md-4 control-label" for="textinput">Produto</label>
                            <div class="col-md-8 ml-auto">
                                <input name="PRODUTO" class="form-control input-md"
                                       type="text"
                                       style="font-weight: 600;
                                              background-color: aliceblue;
                                              border: thick;
                                              color: #023e61;"
                                       readonly
                                       v-model="frmProposta.PRODUTO" />
                            </div>
                        </div>
                        <div class="row" style=" padding-bottom: 10px; ">
                            <label class="col-md-4 control-label" for="textinput">TARIFA</label>
                            <div class="col-md-8 ml-auto">
                                <input name="TARIFA" class="form-control input-md"
                                       type="text"
                                       style="font-weight: 600;
                                              background-color: aliceblue;
                                              border: thick;
                                              color: #023e61;"
                                       readonly
                                       v-model="frmProposta.TARIFA" />
                            </div>
                        </div>
                        <div class="row" style=" padding-bottom: 10px; ">
                            <label class="col-md-4 control-label" for="textinput">Valor Conta</label>
                            <div class="col-md-8 ml-auto">
                                <input name="VALORCONTA" class="form-control input-md"
                                       type="text"
                                       style="font-weight: 600;
                                              background-color: aliceblue;
                                              border: thick;
                                              color: #023e61;"
                                       readonly
                                       v-model="frmProposta.VALORCONTA" />
                            </div>
                        </div>
                        <div class="row" style=" padding-bottom: 10px; ">
                            <label class="col-md-4 control-label" for="textinput">Consumo</label>
                            <div class="col-md-8 ml-auto">
                                <input name="CONSUMO" class="form-control input-md"
                                       type="text"
                                       style="font-weight: 600;
                                              background-color: aliceblue;
                                              border: thick;
                                              color: #023e61;"
                                       readonly
                                       v-model="frmProposta.CONSUMO" />
                            </div>
                        </div>
                        <div class="row" style=" padding-bottom: 10px; ">
                            <label class="col-md-4 control-label" for="textinput">Concessionária</label>
                            <div class="col-md-8 ml-auto">
                                <input name="CONCESSIONARIA" class="form-control input-md"
                                       type="text"
                                       style="font-weight: 600;
                                              background-color: aliceblue;
                                              border: thick;
                                              color: #023e61;"
                                       readonly
                                       v-model="frmProposta.CONCESSIONARIA" />
                            </div>
                        </div>
                         <div class="row" style=" padding-bottom: 10px; ">
                            <label class="col-md-4 control-label" for="textinput" style="padding-left: 10px">Possui Proposta Santander ?</label>
                            <div class="col-md-8 ml-auto">
                                <input name="CONCESSIONARIA" class="form-control input-md"
                                       type="text"
                                       style="font-weight: 600;
                                              background-color: aliceblue;
                                              border: thick;
                                              color: #023e61;"
                                       readonlyT
                                       v-model="frmProposta.PROP_SANTANDER" />
                            </div>
                        </div>
                         <div class="row" style=" padding-bottom: 10px; ">
                            <label class="col-md-4 control-label" for="textinput" style="padding-left: 10px">Solicitou Orçamento ?</label>
                            <div class="col-md-8 ml-auto">
                                <input name="CONCESSIONARIA" class="form-control input-md"
                                       type="text"
                                       style="font-weight: 600;
                                              background-color: aliceblue;
                                              border: thick;
                                              color: #023e61;"                                              
                                       readonly
                                       v-model="frmProposta.VISITA_TECNICA" />
                            </div>
                        </div>
                         <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style type="text/css">
    .greenRow {
        background-color: #c5f1ce;
    }

    .yellowRow {
        background-color: #faf3d6;
    }

    .redRow {
        background-color: #fdcccc;
    }

    dl dt {
        display: inline-block;
        width: 20px;
        height: 20px;
        vertical-align: middle;
    }

    dl dd {
        display: inline-block;
        margin: 0px 10px;
        padding-bottom: 0;
        vertical-align: middle;
    }

    dl dt.yellowLegend {
        background: #f9f1cf;
    }

    dl dt.greenLegend {
        background: #87db98;
    }
    
</style>
<script>
    import "vue-good-table/dist/vue-good-table.css";

    import { VueGoodTable } from "vue-good-table";
    export default {
        name: 'Integracao',
        props: {
            msg: String
        },
        components: {
            VueGoodTable
        },
        data() {
            return {
                loadingDistribuicao: true,
                frmProposta: {
                    ID_LEAD: '',
                    NOME: '',
                    DOCUMENTO: '',
                    NASCIMENTO: '',
                    EMAIL: '',
                    CIDADE: '',
                    TELEFONE: '',
                    CEP: '',
                    PRODUTO: '',
                    CODIGO_PRODUTO: '',
                    TARIFA: '',
                    VALORCONTA: '',
                    CONSUMO: '',
                    CONCESSIONARIA: '',
                    PROP_SANTANDER:'',
                    VISITA_TECNICA:''
                },
                registros: [],
                columns: [

                    { label: "Código", field: "ID" },
                    { label: "Nome", field: "NOME" },
                    { label: "E-Mail", field: "EMAIL" },
                    { label: "CEP", field: "CEP" },
                    { label: "Cidade", field: "CIDADE" },
                    { label: "UF", field: "UF" },
                    { label: "Status", field: "DIST_STATUS" },
                    { label: '', field: 'before' },

                ]
            }
        },
        mounted() {
            this.getDados();
        },
        methods: {
            rowStyleClassFn(row) {
                
                if (row.DIST_STATUS == 'Aprovado') {
                    return 'greenRow';
                }
                else if (row.DIST_STATUS == 'Pendente') {
                    return 'yellowRow';
                }
                else if (row.DIST_STATUS == 'Não respondido') {
                    return 'redRow';
                }
                else if (row.DIST_STATUS == 'Recusado') {
                    return 'redRow';
                }
                else {
                    return 'yellowRow';
                }
            },
            VisualizarProposta: function (pdist_id) {
                
                var obj = this;
                var xhr = new XMLHttpRequest();
                xhr.onreadystatechange = () => {
                    if (xhr.readyState == 4 && xhr.status == 200) {
                        let json = JSON.parse(xhr.responseText);
                        json.forEach((element, index) => {
                            obj.frmProposta.ID_LEAD = element.ID_LEAD;
                            obj.frmProposta.NOME = element.NOME;
                            obj.frmProposta.CIDADE = element.CIDADE;                            
                            obj.frmProposta.EMAIL = element.EMAIL;
                            obj.frmProposta.TELEFONE = element.TELEFONE;
                            obj.frmProposta.CEP = element.CEP;
                            obj.frmProposta.PRODUTO = element.PRODUTO;
                            obj.frmProposta.CODIGO_PRODUTO = element.CODIGO_PRODUTO;
                            obj.frmProposta.TARIFA = element.TARIFA;
                            obj.frmProposta.VALORCONTA = element.VALORCONTA;
                            obj.frmProposta.CONSUMO = element.CONSUMO;
                            obj.frmProposta.CONCESSIONARIA = element.CONCESSIONARIA;
                            obj.frmProposta.PROP_SANTANDER = element.PROP_SANTANDER;
                            obj.frmProposta.VISITA_TECNICA = element.VISITA_TECNICA;
                            $("#modal-proposta").modal("show");
                        });
                    }
                }
                xhr.open("POST", this.$apiUrl + "CalculadoraSolar.svc/getlead");
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.withCredentials = true;
                xhr.send(JSON.stringify({
                    DIST_ID: pdist_id
                }))

            },
            clickAceitarRecusar: function (pid, pacao) {
                
                var xhr = new XMLHttpRequest();
                xhr.onreadystatechange = () => {
                    
                    if (xhr.readyState == 4 && xhr.status == 200) {
                        
                        let json = JSON.parse(xhr.responseText);
                        swal({
                            title: "Atualizada com sucesso",
                            icon: "success",                            
                        });
                        this.getDados();
                    }
                }
                xhr.open("POST", this.$apiUrl + "CalculadoraSolar.svc/getrefuseacceptedlead");
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.withCredentials = true;
                xhr.send(JSON.stringify({
                    id: pid, acao: pacao
                }))

            },
            getDados: function () {
                this.registros = [];
                var xhr = new XMLHttpRequest();
                xhr.onreadystatechange = () => {
                    
                    if (xhr.readyState == 4 && xhr.status == 200) {
                        
                        let json = JSON.parse(xhr.responseText);
                        json.forEach((element, index) => {
                            let item = {};
                            item.ID = element.ID;
                            item.NOME = element.NOME;
                            item.EMAIL = element.EMAIL;
                            item.CEP = element.CEP;
                            item.CIDADE = element.CIDADE;
                            item.UF = element.UF;
                            item.DIST_STATUS = element.DIST_STATUS;
                            this.registros.push(item);
                        });
                        this.loadingDistribuicao = false;
                    }
                }
                xhr.open("POST", this.$apiUrl + "CalculadoraSolar.svc/getmyintegrations");
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.withCredentials = true;
                xhr.send();
            }
        }
    }
</script>
